import { slugifyString } from '@/helpers'

export const DEFAULT_BLOG_AUTHOR_NAME = 'Vanishing Inc.'

export function normalizeBlogAuthorName(authorName?: string | null): string {
  const trimmed = authorName?.trim()
  return trimmed || DEFAULT_BLOG_AUTHOR_NAME
}

export function blogAuthorSlug(authorName?: string | null): string {
  return slugifyString(normalizeBlogAuthorName(authorName)) || 'vanishing-inc'
}

export function normalizeCreatorUrlStub(urlStub?: string | null) {
  const slug = slugifyString(urlStub ?? '')
  return slug || undefined
}

export function blogAuthorHref(authorName?: string | null): string {
  return `/blog/authors/${blogAuthorSlug(authorName)}/`
}
